import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import loginReducer from "../login/store/LoginSlice";
import currentUser from "../home/store/slices/current-user";
import feedbackSlice from "../home/store/slices/feedback";
import eventBannerSlice from "../home/store/slices/event-banner";
import courseSlice from "../home/store/slices/course";
import instituteSlice from "../home/store/slices/institute";
import applicationSlice from "../home/store/slices/application";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const store = configureStore({
	reducer: {
		login: loginReducer,
		currentUser: currentUser.reducer,
		[feedbackSlice.reducerPath]: feedbackSlice.reducer,
		[eventBannerSlice.reducerPath]: eventBannerSlice.reducer,
		[courseSlice.reducerPath]: courseSlice.reducer,
		[instituteSlice.reducerPath]: instituteSlice.reducer,
		[applicationSlice.reducerPath]: applicationSlice.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(
			feedbackSlice.middleware,
			eventBannerSlice.middleware,
			courseSlice.middleware,
			instituteSlice.middleware,
			applicationSlice.middleware,
		),
	devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export const { dispatch } = store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
